import config from 'react-global-configuration';
import type { AppOptions } from '../types';

export let APP_ENV = process.env.REACT_APP_ENV;
export const __DEBUG__ = APP_ENV !== 'production';
export const USE_SENTRY = process.env.REACT_APP_SENTRY_ENABLED?.toLowerCase() === "true";
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const REACT_APP_VERSION = process.env.REACT_APP_VERSION;

export const MULTILINGUAL = true;
export const DEFAULT_LANGUAGE = 'nl';
export const SITE_NAME = process.env.REACT_APP_SITE_NAME || 'uncinc_frontend';

export const IS_SERVER = !(
  typeof window !== 'undefined'
  && window.document
  && window.document.createElement
);
export const IS_CLIENT = !IS_SERVER;

export let API_URL = process.env.REACT_APP_API_URL || "/api";
// export let API_URL = 'http://localhost:3000/api'; // <- For local proxy.

// Searchkit.
export let SEARCHKIT_HOST_URL = process.env.REACT_APP_SEARCHKIT_HOST_URL || '/api-proxy/elasticsearch-proxy?_api_proxy_uri=';
export const SEARCHKIT_INDEX_ALL_CONTENT = process.env.REACT_APP_SEARCHKIT_INDEX_ALL_CONTENT || 'elasticsearch_index_uncinc_content_all';
export const SEARCHKIT_INDEX_LOCATIONS = process.env.REACT_APP_SEARCHKIT_INDEX_LOCATIONS || 'elasticsearch_index_uncinc_locations';
export const SEARCHKIT_INDEX_ALL_LOCATION_ENTITIES = process.env.REACT_APP_SEARCHKIT_INDEX_ALL_LOCATION_ENTITIES || 'elasticsearch_index_uncinc_location_all_entities';

export let APP_OPTIONS = {
  apiUrl: API_URL,
  element: '',
  parameters: {
    env: 'production',
    searchkitIndexAllContent: 'elasticsearch_index_uncinc_content_all',
    relatedArticlesMaxAgeMonths: 12,
  }
};

// The value is where the breakpoint starts (mobile-first).
// These values are taken from '/src/src/styles/assets/_variables.scss'.
export const SCREEN_MOBILE = 0; // xs
export const SCREEN_TABLET = 576; // sm
export const SCREEN_NORMAL = 768; // md
export const SCREEN_WIDE = 1200; // lg
export const SCREEN_HUGE = 1560; // xl

export const CONTENT_TYPE_ARTICLE = 'article';
export const CONTENT_TYPE_BASIC_PAGE = 'basic_page';
export const CONTENT_TYPE_EVENT = 'event';
export const CONTENT_TYPE_FAQ = 'faq';
export const CONTENT_TYPE_HOMEPAGE = 'homepage';
export const CONTENT_TYPE_LANDING_PAGE = 'landing_page';
export const CONTENT_TYPE_OVERVIEW_PAGE = 'overview_page';
export const CONTENT_TYPE_PARTNER ='partner';
export const CONTENT_TYPE_PROJECT = 'project';
export const CONTENT_TYPE_VACANCY = 'vacancy';

export const HOMEPAGE_COLOR = 'f2f8ed';
export const WHITE = 'ffffff';
export const BLACK = '202020';

// Use config to share static configuration between components and packages.
config.set({
  'SITE_NAME': SITE_NAME,
  'MULTILINGUAL': MULTILINGUAL,
  'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
  'API_URL': API_URL,
  'REACT_APP_VERSION': REACT_APP_VERSION,
  'SCREEN_XS': SCREEN_MOBILE,
  'SCREEN_SM': SCREEN_TABLET,
  'SCREEN_MD': SCREEN_NORMAL,
  'SCREEN_LG': SCREEN_WIDE,
  'SCREEN_XL': SCREEN_HUGE,
  'PAGE_TRANSITION_SPEED': 200,

  // Set freeze to false to allow overwriting the configs based on the
  // options passed to window.reactFrontend
}, { freeze: false });

export function saveConstants(options: AppOptions) {
  APP_OPTIONS = options;

  if (options.parameters.env) {
    APP_ENV = options.parameters.env;
  }

  if (options.apiUrl) {
    API_URL = options.apiUrl;
  }

  if (APP_ENV === 'development') {
    // Use proxy in dev to prevent CORS issues.
    API_URL = 'http://localhost:3000/api';
    SEARCHKIT_HOST_URL = 'http://localhost:3000/search';
  }

  // Update the config.
  config.set({
    'SITE_NAME': SITE_NAME,
    'MULTILINGUAL': MULTILINGUAL,
    'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
    'API_URL': API_URL,
    'REACT_APP_VERSION': REACT_APP_VERSION,
    'SCREEN_XS': SCREEN_MOBILE,
    'SCREEN_SM': SCREEN_TABLET,
    'SCREEN_MD': SCREEN_NORMAL,
    'SCREEN_LG': SCREEN_WIDE,
    'SCREEN_XL': SCREEN_HUGE,
    'PAGE_TRANSITION_SPEED': 200,
  });
}
